import React from 'react';
import { CheckIcon } from 'lucide-react';
import { dreamOutcomes } from '../data/content';
export function DreamSection() {
  return <section className="w-full bg-forest-800 py-16 lg:py-24" data-id="element-63" data-mp="2u6u5c4ks6hwi">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-64" data-mp="39560u7wf3km3">
        <h2 className="font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-65" data-mp="392jto9dfv74e">
          Imagine walking into your space tomorrow and seeing it clean
        </h2>
        <ul className="mx-auto mt-10 grid max-w-2xl gap-3 text-left" data-id="element-66" data-mp="2gggw7yw5kx5l">
          {dreamOutcomes.map(outcome => <li key={outcome} className="flex items-center gap-4 rounded-md bg-forest-900/60 px-5 py-4 text-lg text-white" data-id="element-67" data-mp="2bifg9mu0xdyc">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-ember-500" data-id="element-68" data-mp="2q7ld545e2s32">
                <CheckIcon className="h-4 w-4 text-ink-900" aria-hidden="true" data-id="element-69" data-mp="1xphffkytatne" />
              </span>
              {outcome}
            </li>)}
        </ul>
        <p className="mx-auto mt-10 max-w-2xl text-lg text-forest-100" data-id="element-70" data-mp="1splanjiaiy6s">
          That&apos;s not a fantasy. That&apos;s what happens when you work with someone local, who
          actually cares, and who shows up and gets it done.
        </p>
      </div>
    </section>;
}